import React from 'react';
import {Modal} from 'react-bootstrap';

const ModalPopup = (props)=>{
  return (
    <Modal
      {...props}
      // size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="text-center">
          {props.modaltitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.modalbody}
      </Modal.Body>
      <Modal.Footer>
        {props.modalactions}
      </Modal.Footer>
    </Modal>
  );
}

export default ModalPopup;